import { CheckCircleFilled, PlusOutlined } from "@ant-design/icons";
import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  notification,
  Row,
  Select,
  Spin,
  Upload,
} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useState } from "react";
import Support from "../assets/images/support.png";
import { ImageLogo } from "../AppStyle";
import {
  useCategoryListQuery,
  useCreateTicketMutation,
  useGetBranchesQuery,
  useGetUsersQuery,
} from "../graphql/generated/hooks";
import { NormalText, LightText } from "../components/Typography";
import { useAppContext } from "../context/app/context";
import { endpoint } from "../graphql";
import { useFormik } from "formik";
import * as Yup from "yup";

const { Option } = Select;
type Props = {};

export const CreateTicket: React.FC<Props> = (props: Props) => {
  const appContext = useAppContext();

  const { data: users } = useGetUsersQuery();
  const { data: branch } = useGetBranchesQuery();
  const { data: category } = useCategoryListQuery();
  const [createTicketMutation, { error, loading, data, reset }] =
    useCreateTicketMutation();

  const [fileWarning, setFileWarning] = useState(true);
  const [subcategory, setSubcategory] = useState(
    category?.categoryList[0].subcategories,
  );

  const EmailField = () => (
    <Input disabled placeholder="Email" value={formik.values.email} />
  );
  const usersOptions = users?.userList.map((rec, index) => {
    return (
      <Option key={index} value={rec.name}>
        {rec.name}
      </Option>
    );
  });
  const branchOptions = branch?.branchList.map((rec, index) => {
    return (
      <Option key={index} value={rec.name}>
        {rec.name}
      </Option>
    );
  });
  const categoryOptions = category?.categoryList.map((rec, index) => {
    return (
      <Option key={index} value={rec.name}>
        {rec.name} - {rec.arabicName}
      </Option>
    );
  });
  const subcategoryOptions = subcategory?.map((rec, index) => {
    return (
      <Option key={index} value={rec.name}>
        {rec.name} - {rec.arabicName}
      </Option>
    );
  });

  const times = [
    "10:00am - 11:00am",
    "11:00am - 12:00pm",
    "12:00pm - 1:00pm",
    "1:00pm - 2:00pm",
    "2:00pm - 3:00pm",
    "3:00pm - 4:00pm",
    "4:00pm - 5:00pm",
    "5:00pm - 6:00pm",
    "6:00pm - 7:00pm",
    "7:00pm - 8:00pm",
    "8:00pm - 9:00pm",
    "9:00pm - 10:00pm",
  ];

  const contactTimes = times.map((rec, index) => {
    return (
      <Option key={index} value={rec}>
        {rec}
      </Option>
    );
  });

  const defaultUser = appContext.state.odooSession?.name;
  const defaultEmail = appContext.state.odooSession?.username;

  const basicSchema = Yup.object().shape({
    phone: Yup.string()
      .matches(
        /^(05|5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/,
        "The phone number must be 10 digits starting with 05",
      )
      .required(" "),
    branch: Yup.string().required(" "),
    subject: Yup.string()
      .required(" ")
      .max(66, "The subject is too large!")
      .min(3, "The subject is too short!"),
    category: Yup.string().required(" "),
    subcategory: Yup.string().required(" "),
    description: Yup.string()
      .required("Please tell us more about your problem")
      .min(5, "The description is too short!"),
    contactTime: Yup.array().nullable(),
  });

  const onBranchChange = (value) => {
    formik.setFieldValue("branch", value);
  };
  const onUserChange = (value) => {
    formik.setFieldValue("username", value);
    formik.setFieldValue(
      "email",
      users?.userList.find((rec) => rec.name === value)?.email,
    );
  };
  const onCategoryChange = (value) => {
    formik.setFieldValue("category", value);
    formik.setFieldValue("subcategory", "");
    setSubcategory(
      category?.categoryList.find((rec) => rec.name === value)?.subcategories,
    );
  };
  const onSubCategoryChange = (value) => {
    formik.setFieldValue("subcategory", value);
  };
  const onSubjectChange = (value) => {
    formik.setFieldValue("subject", value.target.value);
  };
  const onDescriptionChange = (value) => {
    formik.setFieldValue("description", value.target.value);
  };
  const onAttachmentsChange = (e) => {
    formik.setFieldValue("attachments", e.fileList);
  };
  const onContactTimeChange = (value) => {
    formik.setFieldValue("contactTime", value);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file.originFileObj);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const formik = useFormik({
    async onSubmit(values: any, formikHelpers) {
      try {
        const attachments: any = [];
        for (let i = 0; i < values.attachments?.length; i++) {
          const element = values.attachments[i];
          attachments.push({
            base64: await toBase64(element),
            fileName: element.name,
          });
        }
        await createTicketMutation({
          variables: {
            subject: values.subject.trim(),
            description: values.description.trim(),
            username: values.username,
            email: values.email,
            phone: values.phone,
            category: values.category,
            sub_category: values.subcategory,
            branch: values.branch,
            attachments: attachments,
            contactTime: values.contactTime,
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    validationSchema: basicSchema,
    enableReinitialize: true,
    validateOnMount: true,
    validateOnBlur: true,
    initialValues: {
      username: defaultUser,
      branch: "",
      email: defaultEmail,
      phone: "",
      category: "",
      subcategory: "",
      subject: "",
      description: "",
      attachments: [],
    },
  });

  const normFile = (file) => {
    if (file.fileList.length === 0) setFileWarning(true);
    else setFileWarning(false);
    if (Array.isArray(file)) {
      return file;
    }
    return file && file?.fileList;
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log("Failed:", errorInfo);
  };

  const card = {
    borderRadius: "12px",
    boxShadow: "0 4px 16px rgba(16, 24, 40, 0.06)",
  };

  function beforeUpload(file) {
    const isLt100M = file.size / 1024 / 1024 < 101;
    if (!isLt100M) {
      notification["error"]({
        message: `File must smaller than 100MB!`,
      });
    }
    return isLt100M || Upload.LIST_IGNORE;
  }
  return (
    <Card style={card} className="create-ticket-card">
      <Row align="middle" justify="center" style={{ marginLeft: "1%" }}>
        <Col md={24} sm={24} xs={24}></Col>
        <Col md={15} xs={24}>
          <Row gutter={[0, 30]}>
            <Col span={24}>
              <NormalText size={1.8} bold>
                CREATE TICKET | إنشاء تذكرة
              </NormalText>
              <NormalText color="#595959">
                .فضلاً قم بتعبئة النموذج وسيقوم أحد ممثلي فريق الدعم بالرد عليكم
                في مدة أقصاها يومان عمل
              </NormalText>
              <NormalText color="#595959">
                Please fill the form and one of our support agent will contact
                you witihn 2 work days.
              </NormalText>
            </Col>
            <Col span={24}>
              <Form
                name="createTicket"
                onFinish={formik.handleSubmit}
                layout="vertical"
                onFinishFailed={onFinishFailed}
              >
                <Row gutter={[50, 0]} align="middle">
                  <Col md={12} xs={24}>
                    <Form.Item
                      name="usernameLabel"
                      label="Username - اسم المستخدم"
                    >
                      <Select
                        defaultValue={formik.values.username}
                        onChange={onUserChange}
                        showSearch
                        placeholder="Please select a user"
                      >
                        {usersOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Email - البريد الإلكتروني"
                      name="emailLabel"
                    >
                      <EmailField />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Phone - الهاتف"
                      name="phoneLabel"
                      required
                      validateStatus={
                        formik.errors.phone && formik.touched.phone
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.phone && formik.touched.phone
                          ? formik.errors.phone
                          : ""
                      }
                    >
                      <Input
                        name="phone"
                        placeholder="05XXXXXXXX"
                        value={formik.values.phone}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Branch - الفرع"
                      name="branch"
                      required
                      validateStatus={
                        formik.errors.branch && formik.touched.branch
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.branch && formik.touched.branch
                          ? formik.errors.branch
                          : ""
                      }
                    >
                      <Select
                        id="branch"
                        placeholder="Branch"
                        value={formik.values.branch}
                        onChange={onBranchChange}
                        onBlur={formik.handleBlur}
                      >
                        {branchOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Category - الفئة"
                      name="category"
                      required
                      rules={[{ required: true }]}
                      validateStatus={
                        formik.errors.category && formik.touched.category
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.category && formik.touched.category
                          ? formik.errors.category
                          : ""
                      }
                    >
                      <Select
                        id="category"
                        placeholder="Category"
                        onChange={onCategoryChange}
                        value={formik.values.category}
                        onBlur={formik.handleBlur}
                      >
                        {categoryOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Subcategory - الفئة الفرعية"
                      name="subcategory"
                      required
                      validateStatus={
                        formik.errors.subcategory && formik.touched.subcategory
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.subcategory && formik.touched.subcategory
                          ? formik.errors.subcategory
                          : ""
                      }
                    >
                      <Select
                        id="subcategory"
                        placeholder="Subcategory"
                        value={formik.values.subcategory}
                        onChange={onSubCategoryChange}
                        onBlur={formik.handleBlur}
                      >
                        {subcategoryOptions}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Subject - الموضوع"
                      name="subjectLabel"
                      required
                      validateStatus={
                        formik.errors.subject && formik.touched.subject
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.subject && formik.touched.subject
                          ? formik.errors.subject
                          : ""
                      }
                    >
                      <Input
                        name="subject"
                        placeholder="Subject"
                        value={formik.values.subject}
                        onChange={onSubjectChange}
                        onBlur={formik.handleBlur}
                      />
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    <Form.Item
                      label="Preferred Contact Time - أوقات التواصل"
                      name="contactTime"
                      validateStatus={
                        formik.errors.subcategory && formik.touched.contactTime
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.subcategory && formik.touched.contactTime
                          ? formik.errors.subcategory
                          : ""
                      }
                    >
                      <Select
                        id="contactTime"
                        mode="multiple"
                        placeholder="Contact Time"
                        value={formik.values.contactTime}
                        onChange={onContactTimeChange}
                        onBlur={formik.handleBlur}
                      >
                        {contactTimes}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col md={24} xs={24}>
                    <Form.Item
                      label="Description - الوصف"
                      name="descriptionLabel"
                      required
                      validateStatus={
                        formik.errors.description && formik.touched.description
                          ? "error"
                          : ""
                      }
                      help={
                        formik.errors.description && formik.touched.description
                          ? formik.errors.description
                          : ""
                      }
                    >
                      <TextArea
                        name="description"
                        placeholder="Description"
                        rows={4}
                        style={{ resize: "none" }}
                        value={formik.values.description}
                        onChange={onDescriptionChange}
                        onBlur={formik.handleBlur}
                      />
                    </Form.Item>
                  </Col>
                  <Col>
                    <Form.Item
                      name="attachments"
                      label="Attach Files - إرفاق ملفات"
                      getValueFromEvent={normFile}
                    >
                      <Upload
                        listType="picture-card"
                        action={`${endpoint}/upload`}
                        onChange={onAttachmentsChange}
                        beforeUpload={beforeUpload}
                        maxCount={10}
                      >
                        <div>
                          <PlusOutlined />
                          <LightText size={1} style={{ marginTop: 8 }}>
                            Upload
                          </LightText>
                        </div>
                      </Upload>
                    </Form.Item>
                  </Col>
                  {fileWarning ? (
                    <Col md={17} xs={24}>
                      <NormalText color="#8c8c8c">
                        إرفاق ملفات يساعدنا على فهم المشكلة بشكل أوضح
                      </NormalText>
                      <NormalText color="#8c8c8c">
                        Attaching files will help us to understand the issue
                        more clearly
                      </NormalText>
                    </Col>
                  ) : (
                    <Col md={17} xs={24}></Col>
                  )}
                  <Col md={12} xs={24}>
                    <Form.Item>
                      {loading && !error ? (
                        <Spin></Spin>
                      ) : (
                        <Button
                          disabled={loading || !!error || !!data}
                          icon={<CheckCircleFilled />}
                          htmlType="submit"
                          type="primary"
                          size="large"
                        >
                          Submit
                        </Button>
                      )}
                    </Form.Item>
                  </Col>
                  <Col md={12} xs={24}>
                    {data &&
                      !error &&
                      setTimeout(function () {
                        window.location.href = `/support/ticket?name=${data.createTicket.name}`;
                      }, 3000) && (
                        <Alert
                          closable
                          onClose={() => {
                            reset();
                            window.location.href = `/support/ticket?name=${data.createTicket.name}`;
                          }}
                          message={`${data.createTicket.name} created. you will be redirected soon!!`}
                          type="success"
                        ></Alert>
                      )}
                    {error && (
                      <Alert
                        style={{ position: "relative" }}
                        closable
                        onClose={() => reset()}
                        message={error.message}
                        type="error"
                      ></Alert>
                    )}
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
        <Col md={9} xs={0}>
          <ImageLogo
            style={{
              width: "90%",
              marginRight: "10px",
            }}
            src={Support}
            alt="juleb logo"
          />
        </Col>
      </Row>
    </Card>
  );
};
